export type Brand = "orion" | "gemini" | "centaur";

export const BRANDS: readonly Brand[] = ["orion", "gemini", "centaur"] as const;

export const DEFAULT_BRAND: Brand = "orion";

export const BRAND_LABELS: Record<Brand, string> = {
    orion: "Orion",
    gemini: "Gemini",
    centaur: "Centaur",
};

export const isBrand = (value: unknown): value is Brand =>
    typeof value === "string" && (BRANDS as readonly string[]).includes(value);
